module.exports = __webpack_public_path__ + "src/assets/textures/popups/header_short.png";